import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from "@angular/core";
import { ButtonActionComponent } from "../component/button-action/button-action.component";
import { ButtonExportFileComponent } from "../component/button-export-file/button-export-file.component";
import { ButtonFilterTableComponent } from "../component/button-filter-table/button-filter-table.component";
import { ButtonSaveComponent } from "../component/button-save/button-save.component";
import { ButtonCloseDialogComponent } from "../component/button-close-dialog/button-close-dialog.component";
import { ButtonDeleteComponent } from "../component/button-delete/button-delete.component";
import { ButtonCancelComponent } from "../component/button-cancel/button-cancel.component";
import { ButtonCloseComponent } from "../component/button-close/button-close.component";
import { ButtonGobackComponent } from "../component/button-goback/button-goback.component";
import { ButtonEditComponent } from "../component/button-edit/button-edit.component";
import { ButtonNewComponent } from "../component/button-new/button-new.component";
import { GoBackAndTitleComponent } from "../component/go-back-and-title/go-back-and-title.component";
import { ButtonCancelDialogComponent } from "../component/button-cancel-dialog/button-cancel-dialog.component";
import { ButtonActionDialogComponent } from "../component/button-action-dialog/button-action-dialog.component";
import { ButtonAddComponent } from "../component/button-add/button-add.component";
import { SlideFilterAdvancedComponent } from "../component/slide-filter-advanced/slide-filter-advanced.component";
import { InputOtpComponent } from "../component/input-otp/input-otp.component";
import { FullCalendarModule } from "@fullcalendar/angular";
import { GenericTableComponent } from "../component/generic-table/generic-table.component";
import { DialogFormComponent } from "../component/dialog-form/dialog-form.component";
import { MenuesDesplegablesComponent } from "@views/menues-desplegables/menues-desplegables.component";
import { PaginatorComponent } from "@component/paginator/paginator.component";

@NgModule({
  imports: [
    ButtonActionComponent,
    ButtonExportFileComponent,
    ButtonFilterTableComponent,
    ButtonSaveComponent,
    ButtonCloseDialogComponent,
    ButtonDeleteComponent,
    ButtonCancelComponent,
    ButtonCloseComponent,
    ButtonGobackComponent,
    ButtonEditComponent,
    ButtonNewComponent,
    GoBackAndTitleComponent,
    ButtonCancelDialogComponent,
    ButtonActionDialogComponent,
    ButtonAddComponent,
    SlideFilterAdvancedComponent,
    InputOtpComponent,
    FullCalendarModule,
    GenericTableComponent,
    DialogFormComponent,
    MenuesDesplegablesComponent,
    PaginatorComponent
  ],
  declarations: [

  ],

  providers: [
  ],
  exports: [
    ButtonActionComponent,
    ButtonExportFileComponent,
    ButtonFilterTableComponent,
    ButtonSaveComponent,
    ButtonCloseDialogComponent,
    ButtonDeleteComponent,
    ButtonCancelComponent,
    ButtonCloseComponent,
    ButtonGobackComponent,
    ButtonEditComponent,
    ButtonNewComponent,
    GoBackAndTitleComponent,
    ButtonCancelDialogComponent,
    ButtonActionDialogComponent,
    ButtonAddComponent,
    SlideFilterAdvancedComponent,
    InputOtpComponent,
    FullCalendarModule,
    GenericTableComponent,
    DialogFormComponent,
    MenuesDesplegablesComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ComponentModule { }
